import React, { ComponentProps, useEffect, useRef } from "react";
import { Modal } from "../../modal";
import { Dialog, DialogCloseIcon, DialogContent } from "../dialog";

import "./iframe-dialog.css";

export const IFrameDialog = ({
	iframeTitle,
	onClose,
	url,
	...modalProps
}: {
	iframeTitle: string;
	url: string;
	onClose?: () => void;
} & ComponentProps<typeof Modal>) => {
	const iframeRef = useRef<HTMLIFrameElement | null>(null);

	useEffect(() => {
		if (iframeRef.current) {
			iframeRef.current.src = url;
		}
	}, [iframeRef, url]);

	return (
		<Modal {...modalProps}>
			<Dialog className="iframe-dialog" fullScreen>
				<DialogCloseIcon onClick={onClose} />
				<DialogContent>
					<iframe ref={iframeRef} src="" title={iframeTitle} />
				</DialogContent>
			</Dialog>
		</Modal>
	);
};
IFrameDialog.displayName = "IFrameDialog";
